import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() => import('./share-trigger.vue'))
